import React from 'react';
import { compose } from 'recompose';
// import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// const styles = {};

const enhance = compose();

// const tableHead = enhance(({ roles }) => {
const GochiTableHead = enhance(() => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Gochi bill No</TableCell>
        <TableCell>Gochi bill ID</TableCell>
        <TableCell>Shop ID</TableCell>
        <TableCell>Shop name</TableCell>
        <TableCell>Group ID</TableCell>
        <TableCell>Group name</TableCell>
        <TableCell>Email buy</TableCell>
        <TableCell>Gochi type</TableCell>
        <TableCell>Gochi user type</TableCell>
        <TableCell>Amount</TableCell>
        <TableCell>Tax amount</TableCell>
        <TableCell>Price</TableCell>
        <TableCell>Created at</TableCell>
        <TableCell>Coupon count</TableCell>
        <TableCell>Payment type</TableCell>
        <TableCell>Charge amount</TableCell>
      </TableRow>
    </TableHead>
  );
});

export default GochiTableHead;
